import React, { useState, useEffect, useRef } from "react";
import "../styles/nav.sass";
import logo from "../img/logo.webp";
import { useNavigate } from "react-router-dom";

const MobileNav = ({ navNames }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const isInitialRender = useRef(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLinkClick = (section, offset = 0) => {
    navigate("/", { replace: true });

    setTimeout(() => {
      const element = document.querySelector(`.${section}`);
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition + offset,
          behavior: "smooth",
        });
      }
    }, 100);
  };

  const handleLogoClick = () => {
    navigate("/", { replace: true });
  };

  const generateNav = navNames.map((navName) => (
    <li key={navName.id}>
      <p
        onClick={() => {
          handleLinkClick(navName.to, -100);

          setShowMenu(false);
        }}
      >
        {navName.name}
      </p>
    </li>
  ));
  const ChangeMenu = () => {
    if (isInitialRender.current) {
      isInitialRender.current = false; // Ustaw flagę na false po pierwszym renderowaniu
    }
    setShowMenu((prev) => !prev);
  };

  return (
    <nav style={showMenu ? { borderColor: "transparent" } : {}}>
      <div></div>
      <img
        src={logo}
        onClick={() => {
          handleLogoClick();
          setShowMenu(false);
        }}
        alt='Logo'
      />

      <button onClick={ChangeMenu} aria-label='Menu'>
        <span className={showMenu ? "nav_cross" : ""}></span>
        <span className={showMenu ? "nav_cross" : ""}></span>
      </button>
      <ul
        className={
          showMenu
            ? "on_menu"
            : isInitialRender.current
            ? "initial_menu" // Dodaj klasę dla pierwszego renderowania
            : "off_menu"
        }
      >
        {generateNav}
      </ul>
    </nav>
  );
};

export default MobileNav;
